import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { DialogProps, StyleClasses } from '@paintscout/ui'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  FormSectionTitle,
  useClientOptions,
  NewClientForm
} from '@paintscout/ui'
import { useSnackbar } from 'notistack'
import type { FormikHelpers } from 'formik'
import { Form, Formik } from 'formik'
import type { OptionsDocument } from 'paintscout'
import { useCreateClientMutation } from '@paintscout/api'

const useStyles = makeStyles<Theme, CreateLocationDialogProps>(
  (_theme) => ({
    root: {},
    dialogTitle: {},
    dialogContent: {},
    cancel: {},
    confirm: {}
  }),
  { name: 'CreateLocationDialog' }
)

export interface CreateLocationDialogProps extends DialogProps {
  classes?: DialogProps['classes'] & StyleClasses<typeof useStyles>
  onConfirm: () => any
  onCancel: (event: React.MouseEvent<HTMLElement>) => any
}

function CreateLocationDialog(props: CreateLocationDialogProps) {
  const classes = useStyles(props)
  const { onConfirm, onCancel, ...baseDialogProps } = props
  const { enqueueSnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [createClient] = useCreateClientMutation()
  const { options: parentOptions, clientId } = useClientOptions()
  const template = 'trial'
  const product = 'ps'

  const initialValues = {
    options: {
      companyName: { value: '' },
      companyAddress: { value: '' },
      companyPhone: { value: '' },
      companyCity: { value: '' },
      companyProv: { value: '' },
      companyPostal: { value: '' }
    }
  } as OptionsDocument

  async function handleSubmit(values: OptionsDocument, actions: FormikHelpers<OptionsDocument>) {
    setIsLoading(true)
    actions.setStatus({ error: null })
    console.log('my producsts', { prods: parentOptions.options.products, values, clientId })
    try {
      await createClient({
        variables: {
          input: {
            options: values,
            meta: {
              signupMethod: 'corporate',
              product,
              parentCompanyId: clientId
            },
            template
          }
        },
        refetchQueries: ['searchLocations']
      })

      onConfirm()
      enqueueSnackbar('New Location Created', { variant: 'success' })
    } catch (e) {
      console.error(e)
      enqueueSnackbar('Unable to create location', { variant: 'error' })
    }
    actions.setSubmitting(false)
    setIsLoading(false)
  }

  const leftButton = (
    <Button className={classes.cancel} disabled={isLoading} variant="textNoPadding" onClick={onCancel}>
      {'< Back'}
    </Button>
  )

  return (
    <Dialog {...baseDialogProps}>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        <Form>
          <DialogTitle classes={{ root: classes.dialogTitle }}>
            <Typography variant="h2">New Location</Typography>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContent }}>
            <FormSectionTitle title={'Details:'} />
            <NewClientForm />
          </DialogContent>
          <DialogActions leftButton={leftButton}>
            <Button className={classes.confirm} variant={'contained'} disabled={isLoading} type="submit">
              Create
            </Button>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  )
}

export default CreateLocationDialog
